import { Controller } from "react-hook-form";

import {
  Description,
  FormItem,
  CustomSwitch,
  InputLabel,
  Required,
} from "./styles";
import { useIntl } from "react-intl";

export default function ControlledSwitch({
  name,
  control,
  defaultValue,
  disabled = false,
  onChange,
  label,
  required,
  description,
  creator,
  ...props
}) {
  const intl = useIntl();

  const labelIntl = label ? intl.formatMessage({
    id: label,
  }) : null;

  const isRequired = label && required && <Required>*</Required>;
  const hasDesc = description && (
    <Description>
      (
      {intl.formatMessage({
        id: description,
      })}
      )
    </Description>
  );

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FormItem width={props.width}>
          {label && (
            <InputLabel htmlFor={name} creator={creator}>
              {labelIntl}
              {isRequired} {hasDesc}
            </InputLabel>
          )}
          <CustomSwitch
            {...field}
            {...props}
            id={name}
            disabled={disabled}
            checked={field.value}
            onChange={field.onChange}
          />
        </FormItem>
      )}
    />
  );
}